import ContactPointIcon from '@mui/icons-material/Contacts';

export default ContactPointIcon;
